<template>
  <div class="container">
    <h2>Requis du projet {{ project.name }} de {{ project.clientName }}</h2>
    <hr>
    <div class="form-row">
      <div class="form-group col-sm-3">
        <kez-input
          :label="'Numéro d\'identificateur'"
          :number="true"
          id="idField"
          type="number"
          v-model="projectTask.identifierNo"
          validate="required"
        />
      </div>
      <div class="form-group col-sm-3">
        <kez-input id="nameField" :label="'Nom du requis'" v-model="projectTask.name" validate="required"/>
      </div>
      <div class="form-group col-sm-3 addBtn">
        <button
          type="button"
          class="btn btn-action btn-md"
          variant="primary"
          @click="showCollapse = !showCollapse"
          :class="showCollapse ? 'collapsed' : null"
          aria-controls="collapse1"
          :aria-expanded="showCollapse ? 'true' : 'false'"
        >Ajouter des tâches régulières</button>
      </div>
      <!-- Liste des tâches régulieres a ajouter a la tache -->
      <b-collapse id="collapse1" class="mt-2" v-model="showCollapse">
        <table class="table mt-3">
          <thead>
            <tr>
              <th>Type</th>
              <th>Nom</th>
              <th>Heures estimées</th>
              <th>Temps minimum (h)</th>
              <th>Temps maximum (h)</th>
              <th>Multiplicateur</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(task,index) in regularTask" :key="index" v-show="task.isActive==true">
              <td>{{ formattedType(task.typeGuid) }}</td>
              <td>{{ task.name }}</td>
              <td>{{ task.estimatedHours }}</td>
              <td>{{ task.timeMin }}</td>
              <td>{{ task.timeMax }}</td>
              <td>
                <kez-input
                  :label="''"
                  :number="true"
                  type="number"
                  v-model="task.multiplicator"
                  validate="required"
                  :no-label-displayed="true"
                />
              </td>              
            </tr>
          </tbody>
        </table>
        <br>
        <br>
        <div v-show="!isAdd">
        <h4>Tâches déjà assignées</h4>
        <table class="table mt-3">
          <thead>
            <tr>
              <th>Type</th>
              <th>Nom</th>
              <th>Heures estimées</th>
              <th>Temps minimum (h)</th>
              <th>Temps maximum (h)</th>
              <th>Multiplicateur</th>
            </tr>
          </thead>
          <tbody>
			    <tr v-for="(task,index) in filteredRegularTasks" :key="index" v-show="task.isActive==true">
              <td>{{ formattedType(task.typeGuid) }}</td>
              <td>{{ task.name }}</td>
              <td>{{ task.estimatedHours }}</td>
              <td>{{ task.timeMin }}</td>
              <td>{{ task.timeMax }}</td>
              <td>
                <kez-input
                  :label="''"
                  :number="true"
                  type="number"
                  v-model="task.multiplicator"
                  validate="required"
                  :no-label-displayed="true"
                />
              </td>              
            </tr>
          </tbody>
        </table>
        </div>

      </b-collapse>
    </div>
    <!-- -->
    <div class="mt-3 text-right">
      <button
        v-if="isAdd"
        type="submit"
        class="btn btn-action btn-lg"
        @click="add(projectTask)"
      >Ajouter</button>
      <button
        v-if="!isAdd"
        type="submit"
        class="btn btn-action btn-lg"

        @click="completeEdit();showCollapse = false;reset();"
          :class="showCollapse ? 'collapsed' : null"
          aria-controls="collapse1"
          :aria-expanded="false"
      >Sauvegarder</button>
      <button v-if="!isAdd" type="submit" class="btn btn-action btn-lg" @click="reset();showCollapse = false"
          :class="showCollapse ? 'collapsed' : null"
          aria-controls="collapse1"
          :aria-expanded="false"      
      >Cancel</button>
    </div>

    <div class="form-row">
      <div class="search-wrapper form-group col-sm-8">
        <h3 class="mt-3">Liste des requis</h3>
        <p class="mt-3">*Les totaux comprennent: Prog, analyse et QA</p>

      </div>
      <!-- SEARCH -->
      <div class="search-wrapper form-group col-sm-4 headerRequirement pull-right">
        <input type="search" v-model="search" placeholder="Nom du requis" id="searchField">
        <button type="submit" class="btn btn-action btn-sm" v-on:click="resetFields()">
          <i class="material-icons">cancel</i>
        </button>
      </div>

      <!-- -->
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Numéro d'identificateur</th>
            <th>Nom du requis</th>
            <th>Total minimum (h)</th>
            <th>Total maximum (h)</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(task,index) in filteredList" :key="index">
            <td>{{ task.identifierNo }}</td>
            <td>{{ task.name }}</td>
            <td>{{ task.totalMin }}</td>
            <td>{{ task.totalMax }}</td>
            <td>
              <button
                type="submit"
                class="btn btn-action btn-sm"
                @click="edit(task.taskGuid); showCollapse = true"
                :class="showCollapse ? 'collapsed' : null"
                aria-controls="collapse1"
                :aria-expanded="true"
              >
                <i class="material-icons">edit</i>
              </button>
              <button type="submit" class="btn btn-action btn-sm" @click="remove(task.taskGuid);showCollapse = false"
                :class="showCollapse ? 'collapsed' : null"
                aria-controls="collapse1"
                :aria-expanded="false"              
              >
                <i class="material-icons">delete</i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>

    </div>
    <kez-confirm-modal
      v-model="openModalDelete"
      :title="'Supprimer une tâche'"
      :message="'Êtes-vous sur de vouloir supprimer cette tâche?'"
      @confirm="deleteTask()"
    />

    <kez-information-modal v-model="openModalAddRegularTask" :title="'Lié à une tâches régulières'">
      <div>Vous devez inclure au moins une tâche régulière pour cette tâche</div>
    </kez-information-modal>
  </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import bCollapse from "bootstrap-vue/es/components/collapse/collapse";
import bToggle from "bootstrap-vue/es/directives/toggle/toggle";
import KezInput from "@/components/_forms/KezInput";
import KezConfirmModal from "@/components/_modals/KezConfirmModal";
import KezInformationModal from "@/components/_modals/KezInformationModal";
import Search from "@/components/search/Search";

export default {
  components: {
    KezInput,
    KezConfirmModal,
    KezInformationModal,
    bCollapse,
    Search
  },
  directives: {
    bToggle
  },
  data() {
    return {
      isAdd: true,
      selectedTask: null,
      openModalDelete: false,
      openModalAddRegularTask: false,
      isEdit: false,
      tasksToShow: null,
      search: "",
      showCollapse: false,
      requirementsTaskMultiplicator: [],
      nameField: '',
      idField: '',
    };
  },

  computed: {
    filteredList() {
      return this.projectTasks.filter(task => {
        if (task.name && task.name.toLowerCase().includes(this.search.toLowerCase()) && task.isActive == true)
        return task;
      });
    },
    ...mapState("projects", ["project"]),
    ...mapState("projectTasks", ["projectTask", "projectTasks"]),
    ...mapState("regularTasks", [
      "regularTasks",
      "regularTask",
      "filteredRegularTasks"
    ]),
    ...mapGetters("regularTaskTypes", [
      "formattedRegularTaskTypes",
      "formattedType"
    ]),
    ...mapGetters("projectTasks", ["totalMin", "totalMax"]),

    projectId() {
      return this.$route.query.id;
    },
    transposed() {
      let columns = [
        "Numéro d'identificateur",
        "Nom du requis	",
        "Total minimum (h)	",
        "Total maximum (h)	",
        "Actions"
      ];
      return columns.reduce((a, v) => {
        a.push(projectTasks.map(f => f[v]));
        return a;
      }, []);
    }
  },
  watch: {
    regularTask:{
      handler(newVal) {
      }
    },
    regularTasks: {
      handler(newVal) {
        this.tasksToShow = newVal;
      },
      immediate: true
    },

    filteredRegularTasks: {
      handler(newVal) {
        this.tasksToShow = newVal;
      },
      immediate: true
    },

    projectTasks: {
      handler(newVal) {
      },
      immediate: true      
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.$store.dispatch("projects/get", this.$route.query.id);
      this.$store.dispatch("projects/getList");
      this.$store.dispatch("projectTasks/getList", this.$route.query.id);
      this.$store.dispatch("regularTasks/getList");
      this.$store.dispatch("regularTaskTypes/getList");
      this.$store.commit("projectTasks/projectTask", {
        totalMin:0,
        totalMax:0,
        totalQaMax: 0,
        subTotalHourMin: 0
      });
      this.$store.commit("regularTasks/filteredRegularTasks", []);
    },
    add() {
      this.isEdit = true;
      let countIncludeTask = 0;
      for (let i = 0; i < this.regularTask.length; i += 1) {
        if (
          this.regularTask[i].multiplicator === 0 ||
          this.regularTask[i].multiplicator === null
        ) {
          this.tasksToShow[i].relatedProjectRegularTaskGuid = this.$route.query.id;
          countIncludeTask += 1;
        }
      }
      if (countIncludeTask === this.regularTask.length) {
        this.openModalAddRegularTask = true;
      } else if (
        this.projectTask.identifierNo != null &&
        this.projectTask.name != null
      ) {
        this.projectTask.projectGuid = this.$route.query.id;
        this.projectTask.multiplicator = this.regularTask;
        this.$store.dispatch("projectTasks/save", { task: this.projectTask });
        this.$store.commit("projectTasks/projectTask", {});
        this.$store.dispatch("regularTasks/getList");
        this.$store.commit("regularTasks/filteredRegularTasks", []);
        
        this.$router.go();
      }
    },
    deleteTask() {
      this.$store.dispatch("projectTasks/delete", {
        taskGuid: this.selectedTask,
        projectGuid: this.$route.query.id
      });
      this.$store.dispatch("regularTasks/getList");
      this.$store.commit("projectTasks/projectTask", {});
      this.$store.commit("regularTasks/filteredRegularTasks", []);
      this.isAdd = true;
    },
    remove(index) {
      this.selectedTask = index;
      this.openModalDelete = true;
    },
    edit(task) {
      this.isAdd = false;
      this.selectedTask = task;
      this.$store.dispatch("projectTasks/get", task);
      this.$store.dispatch("regularTasks/getListByProject", task);
      this.$store.dispatch("regularTasks/getListByRequirement", task);
      this.$store.dispatch("regularTasks/getListByRequirement", task);    
    },
    setCollapse(){
      showCollapse = true;
    },
    completeEdit() {
      this.projectTask.projectGuid = this.$route.query.id;
      this.projectTask.multiplicator = this.regularTask;

      var valObj = this.regularTasks.filter(function(elem){
      if((elem.multiplicator > 0) || (elem.multiplicator != null) && (this.filteredRegularTasks.length < 1 || this.filteredRegularTasks == undefined)){
        return true; 
      } else {
        return false;        
      }
      });

      if(valObj.length > 0  && this.filteredRegularTasks.length < 1){
      var payload = this.projectTask
      payload.multiplicator = this.regularTask
      this.$store.dispatch("projectTasks/save", { task: payload });  
      }

      if(valObj.length > 0  && this.filteredRegularTasks.length > 0){

        var payload = this.projectTask
        payload.newTasks = valObj;
        payload.multiplicator = this.filteredRegularTasks
        this.$store.dispatch("projectTasks/editAndSave", { task: payload });

      }

      if(valObj.length == 0  && this.filteredRegularTasks.length > 0){
        var payload = this.projectTask
        payload.multiplicator = this.filteredRegularTasks
        this.$store.dispatch("projectTasks/edit", { task: payload });  
      }


    },
    reset() {
      this.$store.commit("projectTasks/projectTask", {});
      this.$store.dispatch("regularTasks/getList");
      this.isAdd = true;
      this.$store.commit("regularTasks/filteredRegularTasks", []);
      this.$store.dispatch("regularTasks/getList");
      //this.$store.filteredRegularTasks = undefined;
    },
    resetFields() {
      this.search = "";
    }
  }
};
</script>

<style>
.addBtn {
  margin-top: 38px;
}
.tableData {
  display: block;
  overflow-x: auto;
  white-space: nowrap;
}
.headerRequirement {
  margin-top: 30px;
}
</style>
